export default () => ({
  me: {},
  items: [],
  pagination: [],
  item: {}
})
